module.exports = __webpack_public_path__ + "static/navybib-72b40346a213d8c39ef564ead29c58c3.png";